<ada-container
	#MainContainer
	id="MainContainer"
	[horizontalSpacing]="'Medium'"
	[padding]="'[&#34;0px&#34;,&#34;1rem&#34;,&#34;0px&#34;,&#34;1rem&#34;]'"
	[verticalSpacing]="'Medium'"
>
	<ada-container
		#Container2
		id="Container2"
		[colCount]="0"
		[horizontalSpacing]="'Small'"
		[verticalAlignmentOfChildren]="'Middle'"
	>
		<ada-text
			#Text3
			id="Text3"
			[content]="'Month By Last Day Setting'"
			[fontWeight]="'Bold'"
		/>
		<ada-signpost
			#Signpost1
			id="Signpost1"
			[icon]="'faInfoCircleOutline'"
		>
			<ada-text
				#Text2
				id="Text2"
				[content]="'This Schedule will occur once every X months on the last day of the month.'"
			/>
		</ada-signpost>
	</ada-container>
	<ada-container
		#Container3
		id="Container3"
		[colCount]="4"
		[horizontalSpacing]="'Medium'"
		[verticalSpacing]="'Medium'"
	>
		<ada-text
			#Text1
			id="Text1"
			[content]="'Recuring Interval in Months'"
		/>
		<ada-container
			#Container1
			id="Container1"
			[colCount]="2"
			[colSpan]="3"
		>
			<ada-input
				#RecurringIntervalInMonthsInput
				id="RecurringIntervalInMonthsInput"
				[debounce]="'500'"
				[isDisabled]="isDisabled"
				[max]="'127'"
				[min]="'1'"
				[placeholder]="'Number of months'"
				[showAsFullWidth]="true"
				[type]="'Number'"
				[value]="numberOfMonths"
				(valueChange)="setNumberOfMonths($event)"
			/>
		</ada-container>
	</ada-container>
</ada-container>
